export default __webpack_public_path__ + "static/media/website.23305339.svg";